import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import CleaningSolutions from "./pages/CleaningSolutions";
import Absorbent from "./pages/Absorbent";
import SpillSolutions from "./pages/SpillSolutions";
import Pinkwater from "./pages/Pinkwater";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ProductFlyer from "./pages/ProductFlyer";

function Layout() {
  const { pathname } = useLocation();
  const isFlyer = pathname.startsWith("/flyer");

  if (isFlyer) {
    return (
      <Routes>
        <Route path="/flyer/absorbent" element={<ProductFlyer product="absorbent" />} />
        <Route path="/flyer/pinkwater" element={<ProductFlyer product="pinkwater" />} />
        <Route path="/flyer/spill" element={<ProductFlyer product="spill" />} />
      </Routes>
    );
  }

  return (
    <>
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cleaning-solutions" element={<CleaningSolutions />} />
          <Route path="/absorbent" element={<Absorbent />} />
          <Route path="/spill-solutions" element={<SpillSolutions />} />
          <Route path="/pinkwater" element={<Pinkwater />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
